import { useSelector } from "react-redux";
import { translate as getTranslate } from '@haldor/ui';

export const useTranslate = () => {
	return getTranslate(useSelector(state => state.Languages.translations));
}